import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { documentService } from "../../../../services/document.services";

const ACCEPT_TYPES = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png";

// Add a new document, or edit the title / replace the file of an existing one
const DocumentForm = ({ isOpen, document, onClose, onSaved }) => {
    const [title, setTitle] = useState("");
    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const isEdit = !!document;

    useEffect(() => {
        if (isOpen) {
            setTitle(document ? document.title : "");
            setFile(null);
            setErrors({});
        }
    }, [isOpen, document]);

    const close = () => {
        if (!loading) onClose();
    };

    const save = () => {
        let formErrors = {};
        if (!title.trim()) formErrors.title = ["The title field is required."];
        if (!isEdit && !file) formErrors.document = ["Please select a file."];
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }

        const formData = new FormData();
        formData.append("title", title.trim());
        if (file) formData.append("document", file);
        if (isEdit) formData.append("id", document._id);

        setLoading(true);
        (isEdit ? documentService.update(formData) : documentService.add(formData))
            .then(() => {
                setLoading(false);
                onSaved();
            })
            .catch((error) => {
                setLoading(false);
                setErrors(error || {});
            });
    };

    return (
        <Modal size="md" backdrop="static" isOpen={isOpen} toggle={close}>
            <ModalHeader toggle={close}>
                {isEdit ? "Edit Document" : "Upload Document"}
            </ModalHeader>
            <ModalBody>
                <div className="form-group">
                    <label>
                        Title <strong className="text-danger">*</strong>
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={title}
                        placeholder="e.g. Washing and Cleaning Instructions"
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    {errors.title && <span className="text-danger">{errors.title}</span>}
                </div>
                <div className="form-group">
                    <label>
                        {isEdit ? "Replace File" : "File"}{" "}
                        {!isEdit && <strong className="text-danger">*</strong>}
                    </label>
                    <input
                        type="file"
                        className="form-control"
                        accept={ACCEPT_TYPES}
                        onChange={(e) => setFile(e.target.files[0] || null)}
                    />
                    <small className="text-muted d-block mt-1">
                        PDF, Word, Excel or image (JPG, PNG), max 10 MB.
                        {isEdit && " Leave empty to keep the current file (" + document.original_name + ")."}
                    </small>
                    {errors.document && <span className="text-danger">{errors.document}</span>}
                </div>
                {errors.common && <span className="text-danger">{errors.common}</span>}
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary mr-2" onClick={close}>
                    Cancel
                </button>
                {loading ? (
                    <button className="btn btn-primary loader-icon" disabled>
                        <Spinner className="img-svg"></Spinner>
                    </button>
                ) : (
                    <button className="btn btn-primary" onClick={save}>
                        {isEdit ? "Save" : "Upload"}
                    </button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default DocumentForm;
